import { connect } from "react-redux";

import { showModal } from "~/store/ducks/domain/ui/modal";

import ShowModal from "./ShowModal";

const mapDispatchToProps = (dispatch, ownProps) => ({
  onEdit: material => event => {
    dispatch(showModal("DLS_USER_MATERIAL_EDIT", { material }));
  },
  onAbort: event => {
    ownProps.hideModal();
  }
});

export default connect(null, mapDispatchToProps)(ShowModal);
